<!-- MsgBox starts-->
<ng-template #contentTemplate>
  <div class="flex flex-col !p-5 rounded-lg shadow bg-white">
    <div class="flex">
      <div
        class="msgbox-icon text-red-600 align-self-start text-2xl mr-3"
        *ngIf="icon && icon !== 'none'"
      >
        <i [class]="getIconClass(icon)"></i>
      </div>

      <div class="msgbox-body">
        <h2 class="msgbox-title mb-2 font-semibold text-gray-800" *ngIf="title">
          {{ title }}
        </h2>
        <p class="msgbox-content text-sm text-gray-600 dark:text-gray-400 leading-relaxed"
        [class]="getContentClass(contentClassList)"
        [innerHTML]="message"
        >
        </p>
      </div>
    </div>

    <div class="msgbox-actions flex items-center mt-3 gap-2">
      <ng-container *ngFor="let button of buttonList; let i = index">
        <ng-container *ngIf="button.type === 'spacing'; else buttonTemplate">
          <div class="flex-1 px-4 py-2"></div>
        </ng-container>
        <ng-template #buttonTemplate>
          <button
            class="flex-1 px-4 py-2 text-sm font-medium rounded-md"
            [class]="
              getButtonStyle(button.style) +
              ' ' +
              getButtonClass(button.classList)
            "
            (click)="onClick(button, $event)"
            (mouseover)="onMouseOver(button, $event)"
            (mouseout)="onMouseOut(button, $event)"
          >
            {{ button.text }}
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-template>
<!-- MsgBox ends-->
